import type { ShipmentStatusEnum } from '@ztechapps/common.contract'
import { StatusToneEnum } from '@ztechapps/common.contract'
import { humanize } from '@ztechapps/common.utils'
import type { LogisticShipmentStatusDetailType } from '../constants/LogisticShipmentStatus'
import { LogisticShipmentStatus } from '../constants/LogisticShipmentStatus'

/**
 * Resolves the badge label and tone for a stored shipment status. A value the status map does not cover falls back to
 * its humanized text with the Draft tone, so the badge never renders without a colour. Used by
 * LogisticShipmentStatusBadge.
 */
export const resolveShipmentStatusDisplay = (status: string): LogisticShipmentStatusDetailType =>
  // The map is keyed by the literal the gateway stores, so a direct index answers the lookup and
  // an unmapped value falls back to the Draft tone — the shape
  // libs/webui/data-tools/src/StatusSelect/StatusSelect.tsx:9 follows. The cast is the one place
  // that free-form string is narrowed to the enum. The fallback is load-bearing: a value no
  // entry covers still needs a tone, because `StatusColorBadge` with no colour passes an empty
  // fill, which re-enables `StatusBadge`'s runtime foreground pick — and that pick composites a
  // transparent fill over an assumed white backdrop and returns black, leaving black text on the
  // page in both themes (libs/webui/util/src/Status/index.tsx:132,140,160-161).
  LogisticShipmentStatus[status as ShipmentStatusEnum] ?? { label: humanize(status), tone: StatusToneEnum.Draft }
